//
export const CONTROLESCOLAR_SET_RESPONSE_PARAMETROS =
  "controlescolar/PARAMETERS"

export const CONTROLESCOLAR_UNSET_NOTIFICACION =
  "controlescolar/UNSET_NOTIFICACION"
export const CONTROLESCOLAR_UNSET_ERROR = "controlescolar/UNSET_ERROR"
export const CONTROLESCOLAR_UNSET_MENSAJE_EXITO =
  "controlescolar/UNSET_MENSAJE_EXITO"

// Descuentos tanto de Inscripcion como colegiatura al momento de la inscripcion
export const CONTROLESCOLAR_GET_DESCUENTOS_INSCRIPCION =
  "controlescolar/GET_DESCUENTOS_INSCRIPCION"
export const CONTROLESCOLAR_GET_DESCUENTOS_INSCRIPCION_SUCCESS =
  "controlescolar/GET_DESCUENTOS_INSCRIPCION_SUCCESS"
export const CONTROLESCOLAR_GET_DESCUENTOS_INSCRIPCION_FAIL =
  "controlescolar/GET_DESCUENTOS_INSCRIPCION_FAIL"
export const CONTROLESCOLAR_UNSET_DESCUENTOS_INSCRIPCION =
  "controlescolar/UNSET_DESCUENTOS_INSCRIPCION"

export const CONTROLESCOLAR_GET_CURP = "controlescolar/GET_CURP"
export const CONTROLESCOLAR_GET_CURP_SUCCESS = "controlescolar/GET_CURP_SUCCESS"
export const CONTROLESCOLAR_GET_CURP_FAIL = "controlescolar/GET_CURP_FAIL"

export const CONTROLESCOLAR_GET_EMAIL = "controlescolar/GET_EMAIL"
export const CONTROLESCOLAR_GET_EMAIL_SUCCESS =
  "controlescolar/GET_EMAIL_SUCCESS"
export const CONTROLESCOLAR_GET_EMAIL_FAIL = "controlescolar/GET_EMAIL_FAIL"

export const CONTROLESCOLAR_GET_ALUMNO = "controlescolar/GET_ALUMNO"
export const CONTROLESCOLAR_GET_ALUMNO_SUCCESS =
  "controlescolar/GET_ALUMNO_SUCCESS"
export const CONTROLESCOLAR_GET_ALUMNO_FAIL = "controlescolar/GET_ALUMNO_FAIL"

export const CONTROLESCOLAR_PUT_ALUMNO = "controlescolar/PUT_ALUMNO"
export const CONTROLESCOLAR_PUT_ALUMNO_SUCCESS =
  "controlescolar/PUT_ALUMNO_SUCCESS"
export const CONTROLESCOLAR_PUT_ALUMNO_FAIL = "controlescolar/PUT_ALUMNO_FAIL"

export const CONTROLESCOLAR_POST_PHOTO = "controlescolar/POST_PHOTO"
export const CONTROLESCOLAR_POST_PHOTO_SUCCESS =
  "controlescolar/POST_PHOTO_SUCCESS"
export const CONTROLESCOLAR_POST_PHOTO_FAIL = "controlescolar/POST_PHOTO_FAIL"

export const CONTROLESCOLAR_LISTA_ALUMNOS = "controlescolar/LISTA_ALUMNOS"
export const CONTROLESCOLAR_LISTA_ALUMNOS_SUCCESS =
  "controlescolar/LISTA_ALUMNOS_SUCCESS"
export const CONTROLESCOLAR_LISTA_ALUMNOS_FAIL =
  "controlescolar/LISTA_ALUMNOS_FAIL"
export const CONTROLESCOLAR_UNSET_LISTA_ALUMNOS =
  "controlescolar/UNSET_LISTA_ALUMNOS"

export const CONTROLESCOLAR_GET_PERSONA = "controlescolar/GET_PERSONA"
export const CONTROLESCOLAR_GET_PERSONA_SUCCESS =
  "controlescolar/GET_PERSONA_SUCCESS"
export const CONTROLESCOLAR_GET_PERSONA_FAIL = "controlescolar/GET_PERSONA_FAIL"

export const CONTROLESCOLAR_PUT_PERSONA = "controlescolar/PUT_PERSONA"
export const CONTROLESCOLAR_PUT_PERSONA_SUCCESS =
  "controlescolar/PUT_PERSONA_SUCCESS"
export const CONTROLESCOLAR_PUT_PERSONA_FAIL = "controlescolar/PUT_PERSONA_FAIL"

export const CONTROLESCOLAR_PUT_ODIRECCION = "controlescolar/PUT_ODIRECCION"
export const CONTROLESCOLAR_PUT_ODIRECCION_SUCCESS =
  "controlescolar/PUT_ODIRECCION_SUCCESS"
export const CONTROLESCOLAR_PUT_ODIRECCION_FAIL =
  "controlescolar/PUT_ODIRECCION_FAIL"

export const CONTROLESCOLAR_LOGOUT = "controlescolar/LOGOUT"
export const CONTROLESCOLAR_SET_LISTAESTADOS = "controlescolar/LISTAESTADOS"

export const CONTROLESCOLAR_SEND_PASSWORD = "controlescolar/SEND_PASSWORD"
export const CONTROLESCOLAR_SEND_PASSWORD_SUCCESS =
  "controlescolar/SEND_PASSWORD_SUCCESS"
export const CONTROLESCOLAR_SEND_PASSWORD_FAIL =
  "controlescolar/SEND_PASSWORD_FAIL"

export const CONTROLESCOLAR_CREATE_ALUMNO = "controlescolar/CREATE_ALUMNO"
export const CONTROLESCOLAR_CREATE_ALUMNO_SUCCESS =
  "controlescolar/CREATE_ALUMNO_SUCCESS"
export const CONTROLESCOLAR_CREATE_ALUMNO_FAIL =
  "controlescolar/CREATE_ALUMNO_FAIL"
